import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors"; // update according to your project

const NotificationManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "white",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    transition: "0.3s",
    display: "flex",
    alignItems: "center",
    gap: "16px",
    minHeight: "120px",
    height: "100%",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subText = {
    color: colors.grayDark,
    opacity: 0.85,
    fontSize: "12px",
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  return (
    <div
      style={{ background: "#ffffff", minHeight: "100vh" }}
      className="flex justify-center items-start p-6"
    >
      <div className="w-full max-w-7xl">

       

        {/* Grid: 3 columns desktop, 1 mobile */}
        <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`} style={{ alignItems: "stretch" }}>

          {/* Add School Notification */}
          <Link to="/add-notification" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-bell" style={{ ...iconStyle, color: "#EF4444" }}></i>
              <div>
                <h2 style={heading}>Add School Notification</h2>
                <p style={subText}>Send notifications to all students and staff.</p>
              </div>
            </div>
          </Link>

          {/* Add Classwise Notification */}
          <Link to="/add-classwise-notification" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-plus-circle" style={{ ...iconStyle, color: "blueviolet" }}></i>
              <div>
                <h2 style={heading}>Add Classwise Notification</h2>
                <p style={subText}>Send notifications to selected classes or sections.</p>
              </div>
            </div>
          </Link>

          {/* Events & Activities */}
          <Link to="/add-events" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-calendar-alt" style={{ ...iconStyle, color: "#06B6D4" }}></i>
              <div>
                <h2 style={heading}>Events & Activities</h2>
                <p style={subText}>Manage upcoming school events and activities.</p>
              </div>
            </div>
          </Link>

          {/* Today's Thought */}
          <Link to="/todays-thought" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-lightbulb" style={{ ...iconStyle, color: "#F97316" }}></i>
              <div>
                <h2 style={heading}>Today's Thought</h2>
                <p style={subText}>Share daily inspirational thoughts with students.</p>
              </div>
            </div>
          </Link>

          {/* Student Achievement */}
          <Link to="/student-achievement" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-user-graduate" style={{ ...iconStyle, color: "#EAB308" }}></i>
              <div>
                <h2 style={heading}>Student Achievement</h2>
                <p style={subText}>Highlight and showcase student achievements.</p>
              </div>
            </div>
          </Link>

          {/* School Achievement */}
          <Link to="/school-achievement" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-school" style={{ ...iconStyle, color: colors.primary }}></i>
              <div>
                <h2 style={heading}>School Achievement</h2>
                <p style={subText}>Celebrate school milestones and awards.</p>
              </div>
            </div>
          </Link>

        </div>
      </div>
    </div>
  );
};

export default NotificationManagement;
